import type { MessengerPosition } from '@widgets/messenger/types'
import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

const usePositionMessages = (widgetId: string) =>
  useWidgetPostMessages<MessengerPosition>(widgetId, 'textmagicMessengerPosition')

export const sendMessengerPositionMessage = (widgetId: string, position: MessengerPosition) => {
  usePositionMessages(widgetId).sendToParent(position)
}

export const subscribeOnMessengerPositionMessages = (
  widgetId: string,
  callback: (payload: MessengerPosition) => void,
) => {
  return usePositionMessages(widgetId).subscribe((event) => {
    callback(event.data.payload)
  })
}
